import { useEffect, useMemo, useState } from "react";
import { v4 as uuid } from "uuid";

import "./addnewclient.css"; // Assuming this CSS provides general styling
import * as XLSX from "xlsx";
import { v4 as uuidv4 } from "uuid";
import axiosinstances, { baseURL } from "../../Helper/useAxios";
import { toast } from "react-toastify";
import { useLocation, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";

import CryptoJS from "crypto-js"; // Import crypto-js

const navigatePage = "/pay-out";

export default function OrderRequest() {
  const rolelist = process.env.REACT_APP_ALLOWED_TXN_ROLELIST;
  const roleListJson = rolelist ? JSON.parse(rolelist) : [];

  const navigate = useNavigate();
  const locations = useLocation();

  const mid = JSON.parse(sessionStorage.getItem("mid"));
  const sessionId = useSelector(
    (state) => state.getprofilereducer?.getprofile?.sessionId
  );
  const reqId = useSelector(
    (state) => state.getprofilereducer?.getprofile?.requestId
  );

  const e = JSON.parse(sessionStorage.getItem("token"));
  const getUniqId = () => {
    const uuid = uuidv4();
    const uuidWithoutDashes = uuid.replace(/-/g, "").toUpperCase();
    return uuidWithoutDashes;
  };
  const headers = {
    Authorization: `Bearer ${e}`,
    "client-id": sessionId,
    "request-id": reqId,
    "Content-Type": "application/json",
  };
  const userIp = useSelector((state) => state.userIpAddReducer.ip);
  const [axiosInstance] = axiosinstances(userIp);

  // State for single payout request form
  const [payoutDetails, setPayoutDetails] = useState({
    name: "",
    mobile: "",
    email: "",
    address: "",
    amount: "",
    transactionType: "IMPS",
    callbackUrl: "https://www.google.com/",
    bank: "",
    ifsc: "",
    account: "",
    vpa: "",
    description: "",
  });

  // State to manage the current view (single or bulk)
  const [viewMode, setViewMode] = useState("single"); // 'single' or 'bulk'

  // State for bulk upload
  const [csvFile, setCsvFile] = useState(null);
  const [bulkPayoutResults, setBulkPayoutResults] = useState([]); // To store results of each API call
  const [isProcessingBulk, setIsProcessingBulk] = useState(false); // To disable button during processing
  const [parsedCsvData, setParsedCsvData] = useState([]);
  const [isVerifying, setIsVerifying] = useState(true);
  const [showOtpForm, setShowOtpForm] = useState(false);
  const [otp, setOtp] = useState("");
  const [mobileForOtp, setMobileForOtp] = useState(""); // if mobile number required
  const [isSubmitting, setIsSubmitting] = useState(false);
  // Define your static salt here.
  //const API_SALT = "2cd1538d57246f8be4a135546c09787"; // Example salt from your image
  const API_SALT = process.env.REACT_APP_SALT;
  const isValidEmail = (email) => {
    const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailPattern.test(email);
  };
  console.log("bulkPayoutResults", bulkPayoutResults);
  const handlerInfoChange = (e) => {
    const { name, value } = e.target;
    let inputValue = value;

    if (name === "mobile") {
      inputValue = value.replace(/\D/g, "").slice(0, 10); // only digits
    } else if (name === "email") {
      inputValue = value.toLowerCase().trim();
    } else if (name === "amount") {
      // Allow only digits and at most one decimal point
      const regex = /^\d*\.?\d{0,2}$/; // allows 2 digits after decimal
      if (!regex.test(value) && value !== "") return; // block invalid input
      inputValue = value;
    }

    setPayoutDetails({
      ...payoutDetails,
      [name]: inputValue,
    });
  };

  const token = JSON.parse(sessionStorage.getItem("sessiontoken"));
  const unique_id = useMemo(() => getUniqId(), []);
  const userId = useMemo(() => JSON.parse(sessionStorage.getItem("uid")), []);
  const verifyToken = async () => {
    setOtp("");
    if (!token) {
      setShowOtpForm(true);
      setIsVerifying(false);
      sendOtp();
      return;
    }
    let payload = {
      requestId: unique_id,
      timestamp: new Date(),
      username: userId,
      password: token,
    };

    try {
      const response = await axiosInstance.post(
        `/api/v1/upi/merchant/user/session/verify`,
        payload,
        {
          headers,
        }
      );

      if (response.status === 200 && response.data == "Session Verified") {
        // token valid
        console.log("res1", response.data);
        setIsVerifying(false);
      } else {
        // invalid token
        sessionStorage.removeItem("sessiontoken");
        setShowOtpForm(true);
        setIsVerifying(false);
      }
    } catch (err) {
      console.error("Token verification failed", err);
      sessionStorage.removeItem("sessiontoken");
      setShowOtpForm(true);
      setIsVerifying(false);
    }
  };
  useEffect(() => {
    if (unique_id && userId) verifyToken();
  }, [unique_id, userId]);
  const handleOtpSubmit = async () => {
    if (!otp) {
      toast.error("Please enter OTP");
      return;
    }
    let payload = {
      requestId: unique_id,
      timestamp: new Date(),
      username: userId,
      password: otp,
    };
    try {
      const res = await axiosInstance.post(
        `/api/v1/upi/merchant/user/otp/verify`,
        payload,
        { headers }
      );

      if (res.status === 200 && res.data?.token) {
        sessionStorage.setItem("sessiontoken", JSON.stringify(res.data.token));
        toast.success("OTP Verified");
        setShowOtpForm(false);
        setIsVerifying(false);
      } else {
        toast.error("OTP verification failed");
      }
    } catch (error) {
      console.error("OTP verification error:", error);
      toast.error("Invalid OTP");
    }
  };
  const sendOtp = async () => {
    let payload = {
      requestId: unique_id,
      timestamp: new Date(),
      username: userId,
      password: "",
    };

    try {
      const res = await axiosInstance.post(
        `/api/v1/upi/merchant/user/otp/generate`,
        payload,
        { headers }
      );
      if (res.status === 200) {
        toast.success("OTP sent to your mobile");
      }
    } catch (error) {
      toast.error("Failed to send OTP");
    }
  };

  const calculateHash = (data, salt) => {
    // Ensure all values are strings for concatenation
    const msgType = "REQUEST_PAYOUT"; // Static as per your example
    const requestId = data.header.requestId;
    const midValue = data.header.mid;
    const customerId = data.customer.id;
    const customerName = data.customer.name;
    const transactionAmount = data.transaction.amount;
    const transactionCallbackUrl = data.transaction.callbackUrl;
    const toBank = data.to.bank;
    const toIfsc = data.to.ifsc;
    const toAccount = data.to.account;
    const toVpa = data.to.vpa || ""; // Ensure VPA is always a string, even if empty

    const hashString = [
      msgType,
      requestId,
      midValue,
      customerId,
      customerName,
      transactionAmount,
      transactionCallbackUrl,
      toBank,
      toIfsc,
      toAccount,
      toVpa,
      salt,
    ].join(""); // Concatenate all parts

    console.log("String for Hashing:", hashString);
    return CryptoJS.SHA256(hashString).toString(CryptoJS.enc.Hex);
  };

  const API_ENDPOINT = "/api/v1/upi/payout/init"; // **Your Actual Payout API Endpoint**

  // Function to make a single API call for a payout
  const makeSinglePayoutApiCall = async (data, requestSource = "single") => {
    setIsSubmitting(true);
    const generatedRequestId = uuid();
    const generatedCustomerId = uuid();
    const currentTimestamp = new Date()
      .toISOString()
      .replace(/\.\d{3}Z$/, ".000Z");

    const basePayload = {
      header: {
        msgType: "REQUEST_PAYOUT",
        requestId: generatedRequestId,
        timestamp: currentTimestamp,
        mid: mid || "YOUR_FALLBACK_MID",
      },
      customer: {
        id: generatedCustomerId,
        name: data.name,
        mobile: data.mobile,
        ...(data.email && { email: data.email }),
        address: data.address,
      },
      transaction: {
        amount: parseFloat(data.amount), // Ensure amount is a number
        type: data.transactionType,
        callbackUrl: data.callbackUrl,
      },
      to: {
        bank: data.bank,
        ifsc: data.ifsc,
        account: data.account,
        vpa: data.vpa || "", // Ensure VPA is always a string
      },
      additional: {
        DESCRIPTION: data.description,
      },
    };

    const calculatedHash = calculateHash(basePayload, API_SALT);

    const requestPayload = {
      ...basePayload,
      hash: calculatedHash,
      //   "//example-salt": API_SALT,
    };

    console.log(
      `[${requestSource}] Request Payload with Hash:`,
      JSON.stringify(requestPayload, null, 2)
    );

    try {
      const response = await axiosInstance.post(API_ENDPOINT, requestPayload, {
        headers,
      });

      if (
        response.status === 200 &&
        response?.data &&
        response.data?.response?.success
      ) {
        if (requestSource === "single") {
          toast.success(`Payout request submitted successfully!`);
          setTimeout(() => {
            goback();
          }, 100);
        }
        //  console.log(`[${requestSource}] Payout Response:`, response.data);
        return {
          success: true,
          status:
            response.data.response?.code || response.data.status || "SUCCESS",
          txnId: response.data.txnId,
          message: response.data.response?.msg || "Success",
          requestData: data,
          responseData: response.data,
        };
      } else {
        const errorMessage =
          response?.response?.data?.message ||
          response?.error ||
          "Failed to process payout request.";
        console.error(`[${requestSource}] API response error:`, response);
        if (requestSource === "single") {
          toast.error(errorMessage);
        }
        return {
          success: false,
          status:
            response.data.response?.code || response.data.status || "FAILED",
          txnId: null,
          message: errorMessage,
          requestData: data,
          responseData: response.data,
        };
      }
    } catch (error) {
      console.error(
        `[${requestSource}] Error submitting payout request:`,
        error
      );
      const errorMessage =
        error?.response?.data?.message ||
        error?.message ||
        "An error occurred during the payout request.";
      if (requestSource === "single") {
        toast.error(errorMessage);
      }
      return {
        success: false,
        status: "ERROR",
        txnId: null,
        message: errorMessage,
        requestData: data,
        responseData: error.response?.data || { error: error.message },
      };
    } finally {
      setIsSubmitting(false); // ✅ Always stop loading, even if error
    }
  };

  // Handler for single form submission
  const handleSubmit = async (e) => {
    e.preventDefault();

    if (payoutDetails.email && !isValidEmail(payoutDetails?.email)) {
      toast.error("Email id is not valid");
      return;
    }
    if (
      !payoutDetails.name ||
      !payoutDetails.mobile ||
      !payoutDetails.amount ||
      //   !payoutDetails.bank ||
      !payoutDetails.ifsc ||
      !payoutDetails.account ||
      !payoutDetails.callbackUrl
      // !payoutDetails.address
    ) {
      toast.error(
        "Please fill all required fields: Customer Name, Mobile, Address, Amount, Transaction Type, Callback URL, Bank, IFSC, Account Number."
      );
      return;
    }

    await makeSinglePayoutApiCall(payoutDetails, "single");
  };

  // Handle CSV file selection
  // const handleFileChange = (e) => {
  //   if (e.target.files.length) {
  //     setCsvFile(e.target.files[0]);
  //   } else {
  //     setCsvFile(null);
  //   }
  // };

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (!file) return;

    const fileExtension = file.name.split(".").pop().toLowerCase();
    const reader = new FileReader();

    reader.onload = (e) => {
      let data = e.target.result;
      let parsedData = [];

      if (fileExtension === "csv") {
        const text = data.split("\n").map((line) => line.trim());
        const headers = text[0].split(",");
        for (let i = 1; i < text.length; i++) {
          if (!text[i]) continue;
          const values = text[i].split(",");
          const row = {};
          headers.forEach((header, idx) => {
            row[header.trim()] = values[idx]?.trim() || "";
          });
          parsedData.push(row);
        }
      } else if (["xlsx", "xls"].includes(fileExtension)) {
        const workbook = XLSX.read(data, { type: "binary" });
        const sheet = workbook.Sheets[workbook.SheetNames[0]];
        parsedData = XLSX.utils.sheet_to_json(sheet);
      }

      setParsedCsvData(parsedData);
      setCsvFile(file);
    };

    if (fileExtension === "csv") {
      reader.readAsText(file);
    } else {
      reader.readAsBinaryString(file);
    }
  };

  // Function to download a sample CSV file
  //  const downloadSampleCsv = () => {
  //   const headers = ["name", "mobile", "amount", "ifsc", "account", "description"];
  //   const sampleRow = {
  //     name: "John Doe",
  //     mobile: "9876543210",
  //     amount: "1000",
  //     ifsc: "SBIN0000001",
  //     account: "1234567890",
  //     description: "Test payout"
  //   };

  //   const csvContent =
  //     headers.join(",") + "\n" + headers.map((h) => sampleRow[h]).join(",");

  //   const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
  //   const url = URL.createObjectURL(blob);
  //   const link = document.createElement("a");
  //   link.setAttribute("href", url);
  //   link.setAttribute("download", "sample_bulk_payout.csv");
  //   document.body.appendChild(link);
  //   link.click();
  //   document.body.removeChild(link);
  // };
  const downloadSampleCsv = () => {
    const headers = ["name", "mobile", "amount", "ifsc", "account"];
    const sampleRow = {
      name: "John Doe",
      mobile: "9876543210",
      amount: "1000",
      ifsc: "SBIN0000001",
      account: "1234567890",
    };

    const csvContent =
      headers.join(",") + "\n" + headers.map((h) => sampleRow[h]).join(",");

    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.setAttribute("href", url);
    link.setAttribute("download", "sample_bulk_payout.csv");
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  // Handle bulk payout processing
  // const handleBulkProcess = () => {
  //   if (!csvFile) {
  //     toast.error("Please select a CSV file first.");
  //     return;
  //   }

  //   setIsProcessingBulk(true);
  //   setBulkPayoutResults([]); // Clear previous results

  //   Papa.parse(csvFile, {
  //     header: true, // Assumes the first row contains headers
  //     skipEmptyLines: true,
  //     dynamicTyping: true, // Attempts to convert numbers to numbers, etc.
  //     complete: async (results) => {
  //       const payoutRequests = results.data;
  //       const newResults = [];

  //       for (const [index, row] of payoutRequests.entries()) {
  //         // Map CSV headers to payoutDetails structure
  //         const payoutData = {
  //           name: row.name || "",
  //           mobile: row.mobile || "",
  //           email: row.email || "",
  //           address: row.address || "",
  //           amount: row.amount || "",
  //           transactionType: row.transactionType || "IMPS", // Default if not in CSV
  //           callbackUrl: row.callbackUrl || "",
  //           bank: row.bank || "",
  //           ifsc: row.ifsc || "",
  //           account: row.account || "",
  //           vpa: row.vpa || "",
  //           // description: row.description || "",
  //         };

  //         // Basic validation for CSV row
  //         if (
  //           !payoutData.name ||
  //           !payoutData.mobile ||
  //           !payoutData.amount ||
  //           // !payoutData.bank ||
  //           !payoutData.ifsc ||
  //           !payoutData.account ||
  //           // !payoutData.address ||
  //           !payoutData.callbackUrl
  //         ) {
  //           newResults.push({
  //             id: `row-${index}`,
  //             status: "Validation Error",
  //             message: "Missing required fields in CSV row.",
  //             requestData: payoutData,
  //             txnId: null,
  //           });
  //           toast.error(`Row ${index + 1}: Missing required fields.`);
  //           continue; // Skip API call for this row
  //         }

  //         if (payoutData.email && !isValidEmail(payoutData.email)) {
  //           newResults.push({
  //             id: `row-${index}`,
  //             status: "Validation Error",
  //             message: "Invalid email in CSV row.",
  //             requestData: payoutData,
  //             txnId: null,
  //           });
  //           toast.error(`Row ${index + 1}: Invalid email.`);
  //           continue;
  //         }

  //         const result = await makeSinglePayoutApiCall(
  //           payoutData,
  //           `bulk-row-${index + 1}`
  //         );
  //         newResults.push({ id: `row-${index}`, ...result });
  //         setBulkPayoutResults([...newResults]); // Update results dynamically
  //       }
  //       setIsProcessingBulk(false);
  //       toast.success("Bulk payout processing complete!");
  //     },
  //     error: (error) => {
  //       console.error("CSV parsing error:", error);
  //       toast.error("Error parsing CSV file.");
  //       setIsProcessingBulk(false);
  //     },
  //   });
  // };

  const handleBulkProcess = async () => {
    if (!csvFile) {
      toast.error("Please select a file first.");
      return;
    }

    setIsProcessingBulk(true);
    setBulkPayoutResults([]); // Clear previous

    const newResults = [];

    for (const [index, row] of parsedCsvData.entries()) {
      const payoutData = {
        name: row.name || "",
        mobile: row.mobile || "",
        email: "",
        address: "",
        amount: row.amount || "",
        transactionType: "IMPS",
        callbackUrl: "https://www.google.com/",
        bank: "",
        ifsc: row.ifsc || "",
        account: row.account || "",
        vpa: "",
        description: "",
      };

      // Basic validation
      if (
        !payoutData.name ||
        !payoutData.mobile ||
        !payoutData.amount ||
        !payoutData.ifsc ||
        !payoutData.account
      ) {
        newResults.push({
          id: `row-${index}`,
          status: "Validation Error",
          message: "Missing required fields.",
          requestData: payoutData,
          txnId: null,
        });
        toast.error(`Row ${index + 1}: Missing required fields.`);
        continue;
      }

      const result = await makeSinglePayoutApiCall(
        payoutData,
        `bulk-row-${index + 1}`
      );
      newResults.push({ id: `row-${index}`, ...result });
    }

    setBulkPayoutResults(newResults); // One-time update
    setIsProcessingBulk(false);
    toast.success("Bulk payout processing complete!");
  };
  const changeViewModel = (value) => {
    verifyToken();
    setViewMode(value);
  };
  const goback = () => {
    navigate(navigatePage);
  };

  if (isVerifying) {
    return (
      <div class="mid-contant">
        <div class="container">
          <div class="row">
            <div class="col-12">
              <div class="registerbox">
                <div>Verifying session...</div>;
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  if (showOtpForm) {
    return (
      <div class="mid-contant">
        <div class="container">
          <div class="row">
            <div class="col-12">
              <div class="registerbox">
                <div className="otp-container">
                  <h4>OTP Verification Required</h4>
                  <input
                    type="text"
                    placeholder="Enter OTP"
                    value={otp}
                    onChange={(e) => setOtp(e.target.value)}
                    className="form-control"
                  />
                  <button
                    onClick={handleOtpSubmit}
                    className="btn btn-primary mt-2 mr-2"
                  >
                    Verify OTP
                  </button>
                  <button onClick={sendOtp} className="btn btn-secondary mt-2">
                    Resend OTP
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div class="mid-contant">
      <div class="container">
        <div class="row">
          <div class="col-12">
            <div class="head">
              <h2>New Payout Request</h2>
              <div className="d-flex justify-content-end mb-3">
                <button
                  className={`btn btn-sm me-2 ${
                    viewMode === "single"
                      ? "btn-primary"
                      : "btn-outline-primary"
                  }`}
                  onClick={() => changeViewModel("single")}
                >
                  Single Payout
                </button>
                <button
                  className={`btn btn-sm ${
                    viewMode === "bulk" ? "btn-primary" : "btn-outline-primary"
                  }`}
                  onClick={() => changeViewModel("bulk")}
                >
                  Bulk Payout (CSV)
                </button>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-12">
              <div class="registerbox">
                {viewMode === "single" && (
                  <div class="row mb-3">
                    <div class="col-12 col-lg-12">
                      <form onSubmit={(e) => handleSubmit(e)}>
                        <div class="row">
                          <div style={{ marginTop: "0px" }} class="separator">
                            <span class="separator_text">Customer Details</span>
                          </div>

                          {/* Customer Name */}
                          <div id="add_account_color" class="col-12 col-md-4">
                            <div class="form-floating">
                              <input
                                required
                                type="text"
                                class="form-control"
                                id="name"
                                name="name"
                                onChange={(e) => handlerInfoChange(e)}
                                value={payoutDetails?.name}
                                placeholder="Enter customer name"
                              />
                              <label htmlFor="name">
                                Customer Name{" "}
                                <span style={{ color: "red" }}>*</span>
                              </label>
                            </div>
                          </div>

                          {/* Mobile Number */}
                          <div id="add_account_color" class="col-12 col-md-4">
                            <div class="form-floating">
                              <input
                                type="tel"
                                pattern="[0-9]{10}"
                                className="form-control"
                                id="mobile"
                                maxLength={10}
                                placeholder="Enter mobile no."
                                name="mobile"
                                onChange={handlerInfoChange}
                                value={payoutDetails.mobile}
                                required
                              />
                              <label htmlFor="mobile">
                                Mobile number{" "}
                                <span style={{ color: "red" }}>*</span>
                              </label>
                            </div>
                          </div>

                          {/* Email ID - NO LONGER REQUIRED */}
                          <div id="add_account_color" class="col-12 col-md-4">
                            <div class="form-floating">
                              <input
                                type="email"
                                class="form-control"
                                id="email"
                                placeholder="Enter email id"
                                name="email"
                                onChange={(e) => handlerInfoChange(e)}
                                value={payoutDetails.email}
                              />
                              <label htmlFor="email">Email ID (optional)</label>
                            </div>
                          </div>

                          {/* Address */}
                          <div id="add_account_color" class="col-12 col-md-12">
                            <div class="form-floating">
                              <input
                                // required
                                type="text"
                                class="form-control"
                                id="address"
                                placeholder="Enter address"
                                name="address"
                                onChange={(e) => handlerInfoChange(e)}
                                value={payoutDetails.address}
                              />
                              <label htmlFor="address">
                                Address (optional)
                              </label>
                            </div>
                          </div>

                          <div style={{ marginTop: "20px" }} class="separator">
                            <span class="separator_text">
                              Transaction Details
                            </span>
                          </div>

                          {/* Amount */}
                          <div id="add_account_color" class="col-12 col-md-12">
                            <div class="form-floating">
                              <input
                                required
                                type="text"
                                step="0.01"
                                class="form-control"
                                id="amount"
                                name="amount"
                                onChange={(e) => handlerInfoChange(e)}
                                value={payoutDetails?.amount}
                                placeholder="Enter amount"
                              />
                              <label htmlFor="amount">
                                Amount <span style={{ color: "red" }}>*</span>
                              </label>
                            </div>
                          </div>

                          {/* Transaction Type (e.g., IMPS, NEFT, RTGS, UPI) */}
                          {/* <div id="add_account_color" class="col-12 col-md-4">
                            <div class="form-floating">
                              <select
                                required
                                class="form-control"
                                id="transactionType"
                                name="transactionType"
                                onChange={(e) => handlerInfoChange(e)}
                                value={payoutDetails.transactionType}
                              >
                                <option value="IMPS">IMPS</option>
                                <option value="NEFT">NEFT</option>
                                <option value="RTGS">RTGS</option>
                                <option value="UPI">UPI</option>
                              </select>
                              <label htmlFor="transactionType">
                                Transaction Type{" "}
                                <span style={{ color: "red" }}>*</span>
                              </label>
                            </div>
                          </div> */}

                          {/* Callback URL */}
                          {/* <div id="add_account_color" class="col-12 col-md-4">
                            <div class="form-floating">
                              <input
                                required
                                type="url"
                                class="form-control"
                                id="callbackUrl"
                                name="callbackUrl"
                                onChange={(e) => handlerInfoChange(e)}
                                value={payoutDetails.callbackUrl}
                                placeholder="Enter callback URL"
                              />
                              <label htmlFor="callbackUrl">
                                Callback URL{" "}
                                <span style={{ color: "red" }}>*</span>
                              </label>
                            </div>
                          </div> */}

                          <div style={{ marginTop: "20px" }} class="separator">
                            <span class="separator_text">
                              Beneficiary Details
                            </span>
                          </div>

                          {/* Bank Name */}
                          <div id="add_account_color" class="col-12 col-md-4">
                            <div class="form-floating">
                              <input
                                // required
                                type="text"
                                class="form-control"
                                id="bank"
                                name="bank"
                                onChange={(e) => handlerInfoChange(e)}
                                value={payoutDetails?.bank}
                                placeholder="Enter bank name"
                              />
                              <label htmlFor="bank">
                                Bank Name (optional)
                                {/* <span style={{ color: "red" }}>*</span> */}
                              </label>
                            </div>
                          </div>

                          {/* IFSC Code */}
                          <div id="add_account_color" class="col-12 col-md-4">
                            <div class="form-floating">
                              <input
                                required
                                type="text"
                                class="form-control"
                                id="ifsc"
                                name="ifsc"
                                onChange={(e) => handlerInfoChange(e)}
                                value={payoutDetails?.ifsc}
                                placeholder="Enter IFSC code"
                              />
                              <label htmlFor="ifsc">
                                IFSC Code{" "}
                                <span style={{ color: "red" }}>*</span>
                              </label>
                            </div>
                          </div>

                          {/* Account Number */}
                          <div id="add_account_color" class="col-12 col-md-4">
                            <div class="form-floating">
                              <input
                                required
                                type="text"
                                class="form-control"
                                id="account"
                                name="account"
                                onChange={(e) => handlerInfoChange(e)}
                                value={payoutDetails?.account}
                                placeholder="Enter account number"
                              />
                              <label htmlFor="account">
                                Account Number{" "}
                                <span style={{ color: "red" }}>*</span>
                              </label>
                            </div>
                          </div>

                          {/* VPA (if applicable for UPI) */}
                          {/* <div id="add_account_color" class="col-12 col-md-12">
                            <div class="form-floating">
                              <input
                                type="text"
                                class="form-control"
                                id="vpa"
                                name="vpa"
                                onChange={(e) => handlerInfoChange(e)}
                                value={payoutDetails?.vpa}
                                placeholder="Enter VPA (optional)"
                              />
                              <label htmlFor="vpa">
                                VPA (Virtual Payment Address)
                              </label>
                            </div>
                          </div> */}

                          {/* Description */}
                          {/* <div id="add_account_color" class="col-12 col-md-12">
                            <div class="form-floating">
                              <textarea
                                class="form-control"
                                id="description"
                                name="description"
                                onChange={(e) => handlerInfoChange(e)}
                                value={payoutDetails?.description}
                                placeholder="Enter description"
                                rows="3"
                              ></textarea>
                              <label htmlFor="description">Description</label>
                            </div>
                          </div> */}

                          <div
                            style={{
                              display: "flex",
                              gap: "10px",
                              marginTop: "20px",
                            }}
                            class="col-12"
                          >
                            <button
                              onClick={goback}
                              type="button"
                              class="btn btn-secondary"
                            >
                              Cancel
                            </button>
                            <button
                              type="submit"
                              class="btn btn-primary"
                              disabled={isSubmitting}
                            >
                              {isSubmitting
                                ? "Processing..."
                                : "Submit Request"}
                            </button>
                          </div>
                        </div>
                      </form>
                    </div>
                  </div>
                )}

                {viewMode === "bulk" && (
                  <div className="bulk-upload-section">
                    <h4 className="mb-3">Upload CSV for Bulk Payout</h4>
                    <div className="mb-3">
                      <label htmlFor="csvFile" className="form-label">
                        Select CSV File:
                      </label>
                      <input
                        type="file"
                        className="form-control"
                        id="csvFile"
                        accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                        onChange={handleFileChange}
                      />
                      <small className="form-text text-muted">
                        CSV/Excel should have headers: name, mobile, amount,
                        ifsc, account
                      </small>
                      {/* <button
                        className="btn btn-secondary btn-sm py-1 px-3 mt-2"
                        onClick={downloadSampleCsv}
                      >
                        Download Sample CSV
                      </button> */}
                      <div className="d-inline-block">
                        <button
                          className="btn btn-secondary btn-sm py-1 px-3 mt-2"
                          onClick={downloadSampleCsv}
                        >
                          Download Sample CSV
                        </button>
                      </div>
                    </div>
                    <button
                      className="btn btn-primary"
                      onClick={handleBulkProcess}
                      disabled={!csvFile || isProcessingBulk}
                    >
                      {isProcessingBulk
                        ? "Processing..."
                        : "Process Bulk Payout"}
                    </button>

                    {bulkPayoutResults.length > 0 && (
                      <div className="mt-4">
                        <h4>Bulk Payout Results</h4>
                        <div style={{ maxHeight: "400px", overflowY: "auto" }}>
                          <table className="table table-striped table-bordered">
                            <thead>
                              <tr>
                                <th>Row #</th>
                                <th>Customer Name</th>
                                <th>Amount</th>
                                <th>Api Status</th>
                                <th>Transaction Status</th>
                                <th>Message</th>
                                <th>Transaction ID</th>
                              </tr>
                            </thead>
                            <tbody>
                              {bulkPayoutResults.map((result, index) => (
                                <tr key={result.id || index}>
                                  <td>{index + 1}</td>
                                  <td>{result.requestData.name}</td>
                                  <td>{result.requestData.amount}</td>
                                  <td
                                    className={
                                      result.success
                                        ? "text-success"
                                        : "text-danger"
                                    }
                                  >
                                    {result.status}
                                  </td>
                                  <td className={"text-warning"}>
                                    {result?.responseData?.status || "NA"}
                                  </td>
                                  <td>{result.message}</td>
                                  <td>{result.txnId || "N/A"}</td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    )}
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
